import { useState, useEffect } from "react";

import MuiOtpInput from "features/muiotpinput/src";
import Typography from "@material-ui/core/Typography";

// Define prop types
interface OTPInputProps {
  otp: string;
  handleotpChange: (value: string|any) => void;
  onResendOtp: () => void;
  onOtpTimerOut: ()=>void;
}

const SECONDS =  300 // 5minutes of token expire

export default function OTPInput({
    otp,
    handleotpChange,
    onResendOtp,
    onOtpTimerOut
}:OTPInputProps){
    const [time, setTime] = useState(0); // Time in seconds
    const [intervalId, setIntervalId] = useState<any>(null);
  
    // Function to format time as MM:SS
    const formatTime = (seconds:number) => {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };
  
    // Start countdown timer
    const startCountdown = () => {
      // Reset time to 60 seconds
      setTime(SECONDS);
  
      // Clear any existing interval
      if (intervalId) clearInterval(intervalId);
  
      // Start a new interval
      const id = setInterval(() => {
        setTime((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(id); // Stop the timer when it reaches 0
            onOtpTimerOut()
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
  
      setIntervalId(id);
    };
  
    // Cleanup on component unmount

    useEffect(() => {
      return () => {
        if (intervalId) clearInterval(intervalId);
      };
    }, [intervalId]);

    useEffect(() => {
        startCountdown()

      return () => {
        if (intervalId) clearInterval(intervalId);
      };
    }, []);


  
    const handleResendOtpClick = ()=>{
      setTime(0)
      clearInterval(intervalId)
      onResendOtp()
      startCountdown()
    }


    return   <div>
    <MuiOtpInput
    value={otp} onChange={handleotpChange} length={6} />

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop:"10px",
      }}
    >
       <Typography
         style={{
           color: "#16151C",
         }}
         variant="body1"
       >
         {formatTime(time)}
      </Typography>

       <Typography
       onClick={handleResendOtpClick}
         style={{
           color: "#7152F3",
           fontWeight: 700,
           cursor: "pointer",
         }}
       >
         Resend
       </Typography>

    </div>
    </div>
}